export default "__VITE_ASSET__CCYEMAAM__"